import { render, staticRenderFns } from "./VImageScroller.vue?vue&type=template&id=6e28b6d0&"
import script from "./VImageScroller.vue?vue&type=script&lang=js&"
export * from "./VImageScroller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports